module.exports = __webpack_public_path__ + "035ac91ce1a1f1a0d11d3b00363686b0.jpg";